import React from "react";
import { Control, Controller } from "react-hook-form";
import Competences, { ICompetencePillsProps } from "./Competences";

interface ICompetencesControllerProps extends Omit<ICompetencePillsProps, "list"> {
	control: Control<any, any>;
	name: string;
}

export const CompetencesController: React.FC<ICompetencesControllerProps> = ({
	control,
	name,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { ref, ...fieldWithoutRef } }) => (
				<Competences {...fieldWithoutRef} {...rest} />
			)}
		/>
	);
};

export default CompetencesController;
